import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'

const descriptor = 'model::feedback::generic::statisticalData'

export default pipe(
  modelComposition(descriptor),
)
